import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Loader from "../component/Loader";

export default function Signup3() {
  const [confirmPassword, setConfirmPassword] = useState("");
  const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false)
  
  const navigate = useNavigate();
  const handleLogin = (e) => {
    setLoading(true)
    e.preventDefault();
    const info = localStorage.getItem("user");
    const user = JSON.parse(info);
    fetch(`${process.env.REACT_APP_API_URL}/signup`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ ...user, password }),
    })
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else if (res.status === 400) {
          alert("A user with this email already exist");
        } else {
          alert("Sorry we're having a server error");
        }
      })
      .then((data) => {
        console.log(data);
        navigate("/verify");
      })
      .catch((err) => console.error(err))
      .finally(()=>setLoading(false))
  };

  return (
    <div className="login-container">
      <Loader loading={loading}/>
      <div className="login-card">
        <h1 className="login-title">Welcome Back</h1>
        <form onSubmit={handleLogin}>
          <label>Password</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Enter your password"
            required
          />
          <label>Confirm password</label>
          <input
            type="password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            placeholder="Enter your password"
            required
          />

          <button type="submit">Signup</button>
        </form>
        <p className="signup-text">
          Already have an account?{" "}
          <span onClick={() => navigate("/login")}>Login</span>
        </p>
      </div>
    </div>
  );
}
